import { StateCreator } from 'zustand';
import { immer } from 'zustand/middleware/immer';

type AuthState = {
	expiresAt: number | null;
	auth0TokenId: string | null;
};

type AuthActions = {
	setToken: (token: string) => void;
	setExpiresAt: (expiresAt: number) => void;
	resetAuth: () => void;
	isTokenValid: () => boolean;
};

export type AuthSlice = AuthState & AuthActions;

export const createAuthSlice: StateCreator<
	AuthSlice,
	[],
	[['zustand/immer', unknown]]
> =
	immer((set, get) => ({
		auth0TokenId: null,
		expiresAt: null,

		/**
		 * Set authentication token
		 * @param {string} token - Authentication token
		 */
		setToken: (token: string) => {
			set((state) => {
				state.auth0TokenId = token;
			});
		},

		/**
		 * Set token expiration time
		 * @param {number} expiresAt - Token expiration timestamp
		 */
		setExpiresAt: (expiresAt: number) => {
			set((state) => {
				state.expiresAt = expiresAt;
			});
		},

		/**
		 * Reset authentication state
		 * Clears authentication data
		 */
		resetAuth: () => {
			set((state) => {
				state.auth0TokenId = null;
				state.expiresAt = null;
			});
		},

		/**
		 * Check if the current token is valid
		 * @returns {boolean} - Whether the token is valid
		 */
		isTokenValid: () => {
			const { auth0TokenId, expiresAt } = get();
			if (!auth0TokenId || !expiresAt) {
				return false;
			}
			// Check if token is expired
			const currentTime = Date.now();
			return currentTime < expiresAt;
		},
	})
);
